import UnitSearchResultsContainer from './UnitSearchResultsContainer';
export default UnitSearchResultsContainer;
